export default __webpack_public_path__ + "static/media/Thalamus_logomark_B-W.9618af38.svg";